export { }

$(function () {

    let progressFooterElement: JQuery<HTMLElement> = $('footer#progress');

    if (progressFooterElement.length > 0) {

        let normalFooterElement: JQuery<HTMLElement> = $('footer.d-flex');

        normalFooterElement.css('padding-bottom', '90px');
    }
});
